import type { TenantSubscriptionWithRelations } from '../../../lib/api/saas.api';
import { Button } from '@/components/ui/button';
import { CommonModal } from '@/components/common/CommonModal';

function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(undefined, {
      dateStyle: 'short',
      timeStyle: 'short',
    });
  } catch {
    return String(value);
  }
}

interface TenantSubscriptionDetailModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly subscription: TenantSubscriptionWithRelations | null;
}

export function TenantSubscriptionDetailModal({
  open,
  onClose,
  subscription,
}: TenantSubscriptionDetailModalProps) {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Tenant Subscription"
      titleId="tenant-subscription-detail-modal-title"
      panelClassName="max-w-lg"
    >
      {subscription ? (
        <dl className="space-y-3 text-sm">
            <div>
              <dt className="font-medium text-muted-foreground">Tenant</dt>
              <dd className="mt-0.5">
                {subscription.tenant?.name ?? subscription.tenant?.code ?? subscription.tenantId}
              </dd>
            </div>
            <div>
              <dt className="font-medium text-muted-foreground">Plan</dt>
              <dd className="mt-0.5">
                {subscription.plan?.name ?? subscription.plan?.code ?? subscription.planId}
              </dd>
            </div>
            <div>
              <dt className="font-medium text-muted-foreground">Starts at</dt>
              <dd className="mt-0.5">{formatDate(subscription.startsAt)}</dd>
            </div>
            <div>
              <dt className="font-medium text-muted-foreground">Ends at</dt>
              <dd className="mt-0.5">{formatDate(subscription.endsAt)}</dd>
            </div>
            <div>
              <dt className="font-medium text-muted-foreground">Active</dt>
              <dd className="mt-0.5">{subscription.isActive ? 'Yes' : 'No'}</dd>
            </div>
        </dl>
      ) : (
        <p className="text-sm text-muted-foreground">No subscription selected.</p>
      )}

      <div className="mt-4 border-t border-border pt-2">
        <Button type="button" variant="outline" onClick={onClose}>
          Close
        </Button>
      </div>
    </CommonModal>
  );
}
